import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const PlaceholderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ActiveLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${colors.purple800};
`
